// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line-img_right[data-v-35faa9e6]{width:.32rem;height:.32rem}.page-div[data-v-35faa9e6]{display:flex;flex-flow:column nowrap;margin:auto .3rem}.line-div_name[data-v-35faa9e6]{font-size:.32rem;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:#333}.line-div[data-v-35faa9e6]{height:1rem;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;border-bottom:.01rem solid #ebebeb}", ""]);
// Exports
module.exports = exports;
